import { type MCPServerInfo } from '../../types';

const NetsuiteServer: MCPServerInfo = {
  serverId: 'NETSUITE',
  name: 'NetSuite',
  slug: 'netsuite',
  description:
    'NetSuite MCP server. Create and retrieve records, run SuiteQL queries, execute saved searches, and access reports directly from your AI assistant.',
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl:
      'https://{netsuiteAccountId}.suitetalk.ai.netsuite.com/services.mcp/v1/all',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: ['netsuiteAccountId'],
    properties: {
      netsuiteAccountId: {
        type: 'string',
        description:
          'Your NetSuite account ID (e.g. 1234567 or 1234567-sb1 for sandbox). Found in Setup → Company → Company Information → Account ID.',
        sensitive: false,
        isUrlParameter: true
      }
    }
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default NetsuiteServer;
